import {Injectable} from "@angular/core";
import {ServiceConfig} from "../app/services-config";
import {AuthorizedService} from "./authorized.service";
import {ResourceService} from "./resource.service";

@Injectable()
export class DocumentService extends ResourceService {
  constructor(authorizedService: AuthorizedService) {
    super(authorizedService, ServiceConfig.document.listUrl, ServiceConfig.document.detailUrl)
  }
}



// WEBPACK FOOTER //
// ./src/services/document.service.ts